import { css, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  enrichedVacancyStatus: css`
    margin-left: auto;
    flex-shrink: 0;
  `,
  tooltip: css`
    display: flex;
  `,
  menuItem: css`
    width: 100%;
    gap: 10px;
    height: 36px;
    flex-shrink: 0;
  `,
  iconContainer: css`
    display: flex;
    flex-shrink: 0;
  `,
  menuItemActions: css`
    display: flex;
    align-items: center;
    margin-left: auto;
    gap: 10px;
  `,
  iconAction: ({ theme }) => css`
    color: ${theme.colors.neutral.variant[60]};

    cursor: pointer;
    padding: 4px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.15s;
  `,
  iconActionTrash: ({ theme }) => css`
    &:hover {
      color: ${theme.colors.tertiary.red[50]};
      background: ${theme.colors.tertiary.red[20]};
    }
  `,
  iconActionEdit: ({ theme }) => css`
    &:hover {
      background: ${theme.colors.neutral.variant[20]};
    }
  `,
  dialogBody: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
